<template>
  <b-modal ref="saveSnapshotModal"
           :title="$t('evaluation.snapshot.save')"
           :ok-title="$t('save')"
           :cancel-title="$t('cancel')"
           centered
           @ok.prevent="saveSnapshot()">
    <form @submit.prevent="saveSnapshot()" @keydown="form.onKeydown($event)">

      <div class="form-group">
        <label for="snapshot-title" class="col-form-label">{{ $t('evaluation.snapshot.name') }} :</label>
        <input v-model="form.title" name="snapshot-title" type="text" class="form-control" maxlength="100">
        <form-error :form="form" field="title"/>
      </div>

      <div class="form-group">
        <label for="snapshot-scholar" class="col-form-label">{{ $t('scholarlevels.scholar.label') }} :</label>
        <select v-model="form.scholar" class="custom-select" name="snapshot-scholar">
          <option v-for="(item, i) in scholarLevels" :value="i">{{ $t('scholarlevels.scholar.' + item.label) }}</option>
        </select>
      </div>

      <div class="form-group">
        <label for="snapshot-professional" class="col-form-label">{{ $t('professionallevels.professional.label') }} :</label>
        <select v-model="form.professional" class="custom-select" name="snapshot-professional">
          <option v-for="(item, i) in professionalLevels" :value="i">{{ $t('professionallevels.professional.' + item.label) }}</option>
        </select>
      </div>

      <div class="form-group">
        <label for="snapshot-fill" class="col-form-label">{{ $t('evaluation.snapshot.fill.label') }} :</label>
        <select v-model="form.filled" class="custom-select" name="snapshot-fill" @change="checkFillOptions()">
          <option v-for="option in fillOptions" :value="option">{{ $t('evaluation.snapshot.fill.' + option) }}</option>
        </select>
        <div v-if="isRelative">
          <label class="col-form-label">{{ $t('evaluation.snapshot.fill.relative') }} :</label>
          <br>
          <input id="father" v-model="relative" type="radio" value="father">
          <label for="father">{{ $t('evaluation.snapshot.fill.father') }}</label>
          <input id="mother" v-model="relative" type="radio" value="mother">
          <label for="mother">{{ $t('evaluation.snapshot.fill.mother') }}</label>
          <input id="other" v-model="relative" type="radio" value="other">
          <label for="other">{{ $t('evaluation.snapshot.fill.other') }}</label>
          <div v-if="relative==='other'">
            <label for="snapshot-fill-other" class="col-form-label">{{ $t('evaluation.snapshot.fill.who') }}
              :</label>
            <textarea v-model="form.filled_relative" name="snapshot-fill-other" class="form-control" rows="1"/>
          </div>
        </div>
        <div v-if="isAlone">
          <label for="snapshot-fill-details" class="col-form-label">{{ $t('evaluation.snapshot.fill.alone') }} :</label>
          <textarea v-model="form.filled_details" name="snapshot-fill-details" class="form-control" rows="2"/>
        </div>
      </div>

      <div class="form-group">
        <label for="snapshot-satisfaction" class="col-form-label">{{ $t('satisfactionperceptions.satisfaction.label') }} :</label>
        <select v-model="form.satisfaction" class="custom-select" name="snapshot-satisfaction">
          <option v-for="(item, i) in satisfactionPerceptions" :key="i" :value="i">{{ $t('satisfactionperceptions.satisfaction.' + item.label) }}</option>
        </select>
      </div>

      <div class="form-group">
        <label for="snapshot-comments" class="col-form-label">{{ $t('evaluation.snapshot.comments') }}
          :</label>
        <textarea v-model="form.comments" name="snapshot-comments" class="form-control" rows="8"/>
        <form-error :form="form" field="comments"/>
      </div>
    </form>
    <div v-if="isRequirementsTab && (currentSnapshot && currentSnapshot.accompanying_sheet != null && !savingNew)"
         slot="modal-footer" class="w-100">
      <Checkbox v-model="showSheetForm" name="cbxSheet" class="float-left with-buttons-on-right">{{
      $t('manage.requirements_profiles.display_sheet') }}
      </Checkbox>
      <div class="float-right">
        <b-btn variant="secondary" @click="$refs.saveSnapshotModal.hide()">{{ $t('cancel') }}</b-btn>
        <b-btn variant="primary" @click="saveSnapshot()">{{ $t('save') }}</b-btn>
      </div>
    </div>
  </b-modal>
</template>

<script>

import Vue from 'vue'
import Form from 'vform'
import { mapGetters } from 'vuex'

export default {
  name: 'SaveSnapshotModal',

  data: () => ({
    relative: '',
    isAlone: false,
    isRelative: false,
    fillOptions: [
      'himself',
      'himselfwparent',
      'parent',
      'professional',
      'professionalalone'
    ],
    form: new Form({
      scholar: 1,
      professional: 1,
      satisfaction: 1,
      filled: 'himself',
      filled_details: '',
      filled_relative: '',
      title: '' // new Date(Date.now()).toDateString(),
    })
  }),

  computed: {
    ...mapGetters({
      scholarLevels: 'scholarlevels/scholarlevels',
      professionalLevels: 'professionallevels/professionallevels',
      satisfactionPerceptions: 'satisfactionperceptions/satisfactionperceptions',
      user: 'auth/user'
    })
  },

  mounted () {
    this.resetModal()
  },

  methods: {

    hide () {
      this.$refs.saveSnapshotModal.hide()
    },

    resetModal () {
      this.form.reset()
      this.form.title = new Date(Date.now()).toUserLocaleString(this)
      this.setEdit(false)
    },

    new () {
      this.loadForm()
      this.resetModal()
      this.show()
    },

    saveSnapshot () {
      this.formatFillingDetails()
      this.$emit('saved', this.form)
    },

    formatFillingDetails () {
      this.form.filling_context = 'Filled by recipient'
      if (this.form.filled_relative !== '') {
        this.form.filling_context = 'The ' + this.form.filled + ' is the ' + this.form.filled_relative
      }
      if (this.form.filled_details !== '') {
        this.form.filling_context = this.form.filling_context + ' | ' + this.form.filled_details
      }
    },

    show () {
      this.$refs.saveSnapshotModal.show()
    },

    setEdit (state) {
      this.edit = state
    },

    checkIfAlone () {
      let option = this.form.filled
      if (option === 'parent' || option === 'professional' || option === 'professionalalone') {
        this.isAlone = true
      } else {
        this.isAlone = false
      }
    },

    checkIfRelative () {
      let option = this.form.filled
      if (option === 'himselfwparent' || option === 'professional' || option === 'parent') {
        this.isRelative = true
      } else {
        this.isRelative = false
      }
    },

    checkIfOther () {
      let who = this.relative
      if (who === 'other') {
        return true
      } else {
        this.form.filled_relative = who
        return false
      }
    },

    checkFillOptions () {
      this.checkIfAlone()
      this.checkIfRelative()
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/evaluation/SaveSnapshotModal.vue